

































































































































import Vue from 'vue';
import { ExtensionViewModel } from "../../models/ExtensionViewModel";
import BoxContainer from "../BoxContainer.vue";
import dayjs from 'dayjs';
import {UserViewModel} from "@/models/UserViewModel";

export default Vue.extend( {
  name: "ExtensionDetailsPanel",
  components: {
    BoxContainer
  },
  props: {
    extension: {
      type: Object as () => ExtensionViewModel
    }
  },
  data(): {
    // displayDate: string
  }{
    return{
      // displayDate: ""
    }
  },
  computed: {
    loggedInUser(): UserViewModel {
      return this.$store.state.loggedInUser;
    },
    displayDate(): string {
      return dayjs(this.extension.scheduledWorkDate).format('YYYY-MM-DD');
    }
  },
  mounted() {
    // this.displayDate = dayjs(this.extension.scheduledWorkDate).format('YYYY-MM-DD');
    // console.log("*** mounted method of ExtensionDetailsPanel")
    // console.log( this.extension.scheduledWorkDate );
    // console.log( this.displayDate );
  },
})
